"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("../..");
function renderSideNavigationItem({ current, href, sublist, text, external, className, ...props }, key) {
    return ((0, jsx_runtime_1.jsxs)("li", { className: "usa-sidenav__item", children: [(0, jsx_runtime_1.jsx)(__1.Link, { className: (0, uswds_react_utils_1.createClassString)(current && 'usa-current', className) || undefined, href: href, external: external, ...props, children: text }), sublist && ((0, jsx_runtime_1.jsx)("ul", { className: "usa-sidenav__sublist", children: sublist.map(renderSideNavigationItem) }))] }, key));
}
const SideNavigation = (0, react_1.forwardRef)(({ items, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("nav", { ref: ref, "aria-label": "Secondary navigation", ...props, children: (0, jsx_runtime_1.jsx)("ul", { className: "usa-sidenav", children: items.map(renderSideNavigationItem) }) }));
});
exports.default = SideNavigation;
